import { useState } from 'react';

const faqs = [
  {
    q: '吉泽明步的出生日期和出生地是什么？',
    a: '吉泽明步于1984年3月3日出生于日本东京都。她是双鱼座，血型为A型。',
  },
  {
    q: '吉泽明步是在哪一年正式出道的？',
    a: '吉泽明步于2003年正式出道，当时年仅19岁。她在东京涉谷街头被星探发掘，从此开启了辉煌的演艺生涯。',
  },
  {
    q: '吉泽明步的身高和三围数据是多少？',
    a: '吉泽明步的身高为161cm，三围数据为B86-W58-H86（cm）。她凭借匀称的身材比例和出众的外形条件在业内获得了广泛认可。',
  },
  {
    q: '吉泽明步获得过哪些重要奖项？',
    a: '吉泽明步在其职业生涯中获得了多项重要奖项，包括2008年的最佳女演员奖、2004年的最佳新人奖、2010年的最受欢迎女艺人奖，以及2023年的从业二十周年纪念荣誉等。',
  },
  {
    q: '如何获取吉泽明步的最新动态？',
    a: '你可以关注吉泽明步的官方社交媒体账号（Instagram、Twitter/X、YouTube）获取最新动态，也可以加入官方粉丝俱乐部获取独家内容和优先购票权等福利。',
  },
  {
    q: '本站是吉泽明步的官方网站吗？',
    a: '本站是由粉丝自发创建的吉泽明步资讯站，致力于为粉丝提供全面、权威的相关信息。本站与吉泽明步本人及其经纪公司无直接关联。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500">
              关于吉泽明步的常见问题解答，帮助你快速获取关键信息
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(i)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                >
                  <span className="font-medium text-sm md:text-base text-foreground-900 pr-4">
                    {faq.q}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                    openIndex === i
                      ? 'bg-primary-500 text-background-50 rotate-45'
                      : 'bg-background-100 text-foreground-500'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === i ? 'max-h-96 pb-4' : 'max-h-0'
                  }`}
                >
                  <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}